import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import userMessageColumns from "./userMessageColumns";
import { dateIsInFuture } from "app/utils/filters";

type Props = {
  name: string;
};

const query = gql`
  query AllUserMessages($offset: Int, $limit: Int) {
    user_messages(offset: $offset, limit: $limit) {
      id
      title
      description
      created_at
      updated_at
      expires_at
      user_targeting_type
      snapmin_url
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      offset,
      limit
    }
  })
});

const withRowColors = rows => {
  return rows.map(function(message: any) {
    var m = Object.assign({}, message);
    if (message.user_targeting_type === "draft") {
      m.color = "white";
    } else {
      if (dateIsInFuture(message.expires_at)) {
        m.color = "green";
      } else {
        m.color = "silver_mist";
      }
    }
    return m;
  });
};

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={userMessageColumns}
        defaultColumns={[
          "Id",
          "Title",
          "Expires At",
          "Targeting Type",
          "Status"
        ]}
        rows={
          props.data.user_messages
            ? withRowColors(props.data.user_messages)
            : []
        }
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
